import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MessageorderModel } from 'projects/core/src/lib/models/messageorder.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { MessageorderSettingsComponent } from '../messageorder-settings/messageorder-settings.component';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-messageorder-basedata',
  templateUrl: './messageorder-basedata.component.html',
  styleUrls: ['./messageorder-basedata.component.scss']
})
export class MessageorderBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @ViewChild('settings') settings: MessageorderSettingsComponent;
  @Input() messageorder: MessageorderModel = null;
  @Input() options: any;
  @Output() setEdit = new EventEmitter<string>();

  public form = this.fb.group({
    active: new UntypedFormControl(false),
    title: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl(''),
  });

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.messageorder !== null) {
      if (this.auth.hasRight('admin.messageorder.delete')) {
        this.items.push({
          label: this.transloco.translate('common.labels.delete'),
          icon: 'pi pi-trash',
          styleClass: 'danger-button',
          disabled: (!this.messageorder.deletable),
          command: () => {
            this.onDelete();
          }
        });
      }
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        active: this.form.get('active').value,
        title: this.form.get('title').value,
        description: this.form.get('description').value,
      };
      this.api.saveModel('messageorders', this.messageorder.id, {...payload, ...this.settings.getPayload()}).subscribe({
        next: (result: any) => {
          this.messageorder.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.messageorder.title }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.messageorder.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.messageorder.title }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('messageorders', this.messageorder.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.messageorder.title }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/messageorders']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.messageorder !== null) {
      this.form.patchValue({
        active: this.messageorder.active,
        title: this.messageorder.title,
        description: this.messageorder.description,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

}
